import { useEffect } from 'react'

/** Força tema claro na rota (html class + data-theme) enquanto o layout estiver montado. */
export function useFixedLightRoute(htmlClass: string) {
  useEffect(() => {
    const root = document.documentElement
    root.classList.add(htmlClass)
    const prevTheme = root.getAttribute('data-theme')
    root.setAttribute('data-theme', 'light')

    return () => {
      root.classList.remove(htmlClass)
      if (prevTheme) root.setAttribute('data-theme', prevTheme)
    }
  }, [htmlClass])
}
